/**
 * Stateless "Sync" button for the calendar toolbar (Google Calendar manual
 * re-sync). The caller gates rendering behind `googleCalendarConnected`.
 */
export function CalendarSyncButton({
  isSyncing,
  onSync,
}: {
  isSyncing: boolean;
  onSync: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSync}
      disabled={isSyncing}
      style={{
        background: 'transparent',
        border: '1px solid #DADCE0',
        borderRadius: '22px',
        cursor: isSyncing ? 'default' : 'pointer',
        height: 36,
        width: 70,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        color: 'var(--color-text-muted)',
        fontSize: '13px',
        fontWeight: 500,
        flexShrink: 0,
        justifyContent: 'center',
        opacity: isSyncing ? 0.6 : 1,
        transition: 'background 0.15s',
      }}
      onMouseEnter={(e) => { if (!e.currentTarget.disabled) e.currentTarget.style.background = '#F1F3F4'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
    >
      {isSyncing ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}><circle cx="12" cy="12" r="10" opacity="0.25" /><path d="M12 2a10 10 0 0 1 10 10" /></svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>
      )}
      Sync
    </button>
  );
}
